import {Injectable} from '@angular/core';
import {RequesterService} from "../../shared/services/requester/requester.service";
import {BehaviorSubject} from "rxjs";
import {DbResponse} from "../../shared/interceptors/db-response";
import {Config} from "../../config/config";
import {UserService} from "../../user/user.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {combineLatest} from "rxjs";
import {User} from "../../user/user";
import {CookieService} from "ngx-cookie";

@Injectable({
  providedIn: 'root'
})
export class ExpertsService {

  constructor(
    private _requester: RequesterService,
    private _userService: UserService,
    private _store: Store<fromStore.DbStoreState>,
    private _cookieService: CookieService
  ) {}

  private getExpertsToken(workspaceId): BehaviorSubject<DbResponse> {
    return this._requester.auth.post(`workspaces/${workspaceId}/partners/token`);
  }

  public redirectToExperts(from: string = null, newTab: boolean = false): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getWorkspaceIdEntities)
          )
        ),
        filter(([user, workspaceIdEntities]) => !!user && !!workspaceIdEntities),
        first()
      )
      .subscribe(([user, workspaceIdEntities]) => {
        if (!user.hasExpertsProfile) {
          if (this._cookieService.get('db-testing')) {
            return window.open(`${Config.expertsUrl}`, "_self");
          }
          const updatedUserData = {...user, labels: [...user.labels, 'has-expert-profile']};
          from === 'login' ? window.open(`${Config.expertsUrl}?has_experts_profile=false`, "_self")
            : this.entryToExperts(workspaceIdEntities.ownerWorkspaceId, updatedUserData, newTab);
        } else {
          this.entryToExperts(workspaceIdEntities.ownerWorkspaceId, null, newTab);
        }
        return null;
      });
  }

  public entryToExperts(workspaceId: number, updatedUserData?: User, newTab?: boolean): void {
    updatedUserData && this._userService.updateUserData(updatedUserData)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUser());
        }
      });
    this.getExpertsToken(workspaceId)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe(response => {
        if (response.success) {
          response && response.data && window.open(`${Config.expertsUrl}?tw_partner_token=${response.data.token}`, newTab ? "_blank" : "_self", "noopener");
        }
      });
  }
}
